import { render, staticRenderFns } from "./indexComplain.vue?vue&type=template&id=c31c997c&scoped=true&"
import script from "./indexComplain.vue?vue&type=script&lang=js&"
export * from "./indexComplain.vue?vue&type=script&lang=js&"
import style0 from "./indexComplain.vue?vue&type=style&index=0&id=c31c997c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31c997c",
  null
  
)

export default component.exports